import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link, browserHistory as history } from 'react-router';

import moment from 'moment';
import 'moment-duration-format';

import Label from '@zacousticrepo/grommet-v1-custom/components/Label';
import AgentJibeOvertimeAndDetailOnSurveyQuetions from './AgentJibeOvertimeAndDetailOnSurveyQuetions';
import AgentInteractions from './AgentInteractions';
import UserProfilePresentationControl from '../../../../components/v3/CalibrationScreenV3/UserProfilePresentationControl';
import LoadingControl from '../../../../components/LoadingControl';
import { ProgressBar } from '../../../../components/v3/ProgressBar';
import { Step } from '../../../../components/v3/Step';
import BackArrowIcon from '../../../../icons/v3/BackArrowIcon';
import { dateFormat, jibeTips } from '../../../../constants';
import { pageLoaded } from '../../../../utils';
import { ZRole } from '../../../../generated';

import {
    loadJibeAgentScreen,
    loadAgentInteractions,
    loadAgentJibeProgressOverTimeStats,
    postJibeSession,
    updateProps,
} from '../CalibrationV3ScreenActions';
import { getRandomItem, isDefined } from '../../../../utils';

class CalibrationV3AgentScreen extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showAgentInteractionsPopup: false,
            fromDate: moment().subtract(90, 'd').format(dateFormat),
            toDate: moment().format(dateFormat)
        };

        this.backToSearch = this.backToSearch.bind(this);
        this.closeAgentInteractionsPopup = this.closeAgentInteractionsPopup.bind(this);
        this.showAgentInteractionsPopup = this.showAgentInteractionsPopup.bind(this);

        this.onSelectNewTimeRange = this.onSelectNewTimeRange.bind(this);
        this.saveJibeSession = this.saveJibeSession.bind(this);

        this.getTopPanelNode = this.getTopPanelNode.bind(this);
        this.getAchievementNode = this.getAchievementNode.bind(this);
    }

    componentDidMount() {
        pageLoaded('Agent Details');
        this.props.dispatch(loadJibeAgentScreen(this.props.params?.agentId, this.state.fromDate, this.state.toDate));
    }

    backToSearch = () => {
        this.props.dispatch(updateProps({
            agentCalibrationSummary: undefined,
            agentInteractions: undefined,
            agentJibeProgressOverTimeStats: undefined,
        }));
        history.push('/Jibe/status');
    }

    showAgentInteractionsPopup() {
        this.setState({ showAgentInteractionsPopup: true });
    }

    closeAgentInteractionsPopup() {
        this.setState({ showAgentInteractionsPopup: false });
    }

    onSelectNewTimeRange(fromDate, toDate) {
        this.props.dispatch(updateProps({ agentInteractions: undefined }));
        this.props.dispatch(loadAgentInteractions(this.props.params.agentId, fromDate, toDate));
        this.props.dispatch(loadAgentJibeProgressOverTimeStats(this.props.params.agentId, fromDate, toDate));
    }

    saveJibeSession() {
        const
            {
                agentCalibrationSummary,
            } = this.props;
        if (agentCalibrationSummary) {
            const jibeSession = {
                AgentId: agentCalibrationSummary.agentId,
            };
            this.props.dispatch(postJibeSession(jibeSession));
        }
    }

    getTopPanelNode() {
        const
            {
                selectedAgent,
                agentCalibrationSummary,
                calibratedOnSurveyQuestions,
                currentUser,
            } = this.props;
        let agentName = selectedAgent
            ? selectedAgent.agentName
            : (agentCalibrationSummary)
                ? agentCalibrationSummary.agentName
                : undefined;
        let topPanelNode = <LoadingControl />;

        if (!isDefined(agentCalibrationSummary) || !isDefined(calibratedOnSurveyQuestions)) {
            return <LoadingControl />;
        }

        let isFullyJibed = false;
        let achievedOnesCount = 0;

        calibratedOnSurveyQuestions.map(calibratedOnSurveyQuestion => {
            const calibrationStatusId = `${calibratedOnSurveyQuestion.internalName}CalibrationStatusId`;
            const statusId = agentCalibrationSummary[calibrationStatusId];

            if (statusId === 1) {
                achievedOnesCount = achievedOnesCount + 1;
            }
        });

        if (achievedOnesCount === calibratedOnSurveyQuestions.length) {
            isFullyJibed = true;
        }

        if (!isDefined(agentName) && currentUser && (currentUser.RoleId == ZRole.Agent)) {
            agentName = currentUser.UserName
        }

        if (agentName) {
            var showSessionRequiredButton = false;
            if (currentUser && (currentUser.RoleId == ZRole.Supervisor ||
                currentUser.RoleId == ZRole.Manager || currentUser.RoleId == ZRole.SuperAdmin || currentUser.RoleId == ZRole.Admin)) {
                showSessionRequiredButton = true;
            }

            const lastJibeSession = (agentCalibrationSummary)
                && isDefined(agentCalibrationSummary.lastJibeSession) && agentCalibrationSummary.lastJibeSession != null
                ? moment(agentCalibrationSummary.lastJibeSession) : undefined;
            const daysSinceLastJibeSession = lastJibeSession ? moment(moment()).diff(lastJibeSession, 'days') : '';
            const jibeSessionsPast30DaysCount = (agentCalibrationSummary)
                ? agentCalibrationSummary.jibeSessionsPast30DaysCount : undefined;

            topPanelNode =
                <UserProfilePresentationControl
                    isFullyJibed={isFullyJibed}
                    stats={agentName}
                    showAgentInteractionsPopup={this.showAgentInteractionsPopup}
                    title="View interactions"
                    jibeSessionsPast30DaysCount={jibeSessionsPast30DaysCount}
                    daysSinceLastJibeSession={daysSinceLastJibeSession}
                    showSessionRequiredButton={showSessionRequiredButton}
                    postJibeSession={this.saveJibeSession}
                    backgroundImage="profileAgentWithAvatar" />
        }
        return topPanelNode;
    }

    getAchievementNode() {
        const
            {
                agentCalibrationSummary,
                calibratedOnSurveyQuestions
            } = this.props;

        let steps;
        if (!isDefined(agentCalibrationSummary) || !isDefined(calibratedOnSurveyQuestions)) {
            steps = <LoadingControl />;
        }
        else {
            const startStep = (<Step title="Started" isFirst={true} />);

            let achievedOnes = [];
            let notAchievedOnes = [];
            calibratedOnSurveyQuestions.map(calibratedOnSurveyQuestion => {

                const calibrationStatusId = `${calibratedOnSurveyQuestion.internalName}CalibrationStatusId`;
                const statusId = agentCalibrationSummary[calibrationStatusId];
                if (statusId === 1) {
                    const title = `Jibed on ${calibratedOnSurveyQuestion.shortName}`;
                    const achievedItem = (<Step key={calibratedOnSurveyQuestion.shortName} title={title} isAccomplished={true} />);
                    achievedOnes.push(achievedItem);
                }
                else {
                    const title = `Jibed on ${calibratedOnSurveyQuestion.shortName}`;
                    const notAchievedItem = (<Step key={calibratedOnSurveyQuestion.shortName} title={title} />);
                    notAchievedOnes.push(notAchievedItem);
                }
            });

            let percentage = (100 * (achievedOnes.length)) / (calibratedOnSurveyQuestions.length + 1);

            if (percentage === 40)
                percentage = 42;

            const fullyJibedAchieved = (<Step title="Jibed" isLast={true} isAccomplished={true} />);
            const fullyJibedNotAchieved = (<Step title="Jibed" isLast={true} />);
            let jibedStep = fullyJibedNotAchieved;
            if (notAchievedOnes.length === 0) {
                jibedStep = fullyJibedAchieved;
                percentage = 100;
                //this.setState({ isFullyJibed: true });
            }

            steps = (<div style={{ margin: '38px 32px' }}>
                <ProgressBar percent={percentage}>
                    {startStep}
                    {achievedOnes}
                    {notAchievedOnes}
                    {jibedStep}
                </ProgressBar>
            </div>);
            //}
        }

        return (<div className="flex-item box-style"
            style={{ margin: '0', backgroundImage: `url(${`../../../../../Assets/Images/V3Design/AchievementCopy.png`})`, height: '155px' }}>
            <div className="cuenta-fan-copy-7">
                Achievement
            </div>
            {steps}
        </div>);
    }

    render() {
        const
            {
                calibratedOnSurveyQuestions,
                agentInteractions,
                currentUser,
            } = this.props;

        const topPanelNode = this.getTopPanelNode();
        let backButton = (<div style={{ margin: '10px' }}></div>);
        if (currentUser &&
            (currentUser.RoleId == ZRole.Supervisor || currentUser.RoleId == ZRole.Manager ||
                currentUser.RoleId == ZRole.Admin || currentUser.RoleId == ZRole.SuperAdmin)) {
            backButton = (<div style={{ margin: '4px' }}>
                <Link className="flex " onClick={() => this.backToSearch()}>
                    <span className="cursor-pointer" ><BackArrowIcon /></span>
                    <Label className="cursor-pointer" style={{ fontSize: '18px', marginLeft: '8px' }} >{'back'}</Label>
                </Link>
            </div>);
        }

        let tipOfTheDay;
        let tipOfTheDayMessage = getRandomItem(jibeTips);
        if (currentUser &&
            (currentUser.RoleId == ZRole.Agent)) {
            tipOfTheDay = (<div className="flex-item box-style"
                style={{ height: 'inherit', margin: '0 0 0 12px', maxWidth: '412px', backgroundImage: `url(${`../../../../../../Assets/Images/V3Design/LeftEdge2.png`})` }}>
                <div style={{ minHeight: '80px', marginTop: '8px', marginLeft: '30px' }}>
                    <div>
                        <p className="agent-top-panel-title" style={{ marginBottom: '8px' }}>Tip of the day</p>
                        <span className="las">{tipOfTheDayMessage}</span>
                    </div>
                </div>
            </div>);
        }

        const achievementNode = this.getAchievementNode();

        return (
            <div className="main-page-width">
                {backButton}
                <div className="flex-container" style={{ height: '143px' }}>
                    {topPanelNode}
                    {tipOfTheDay}
                </div>
                <br />
                {achievementNode}
                <br />
                <br />
                <AgentJibeOvertimeAndDetailOnSurveyQuetions
                    onSelectNewTimeRange={this.onSelectNewTimeRange} />
                {this.state.showAgentInteractionsPopup &&
                    (<AgentInteractions
                        onClose={this.closeAgentInteractionsPopup}
                        calibratedOnSurveyQuestions={calibratedOnSurveyQuestions}
                        agentInteractions={agentInteractions}
                    />)}

            </div>);
    }
}

const select = state => ({ ...state.CalibrationV3Screen, ...state.session });

export default connect(select)(CalibrationV3AgentScreen);